.fill {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 0;
  flex: 1;

  display: grid;
  place-items: start center;
  padding: clamp(4rem, 20dvh, 12rem) 1.5rem 1rem;
}
